// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Heading__Jsx3 = require("../../../../uikit/reason/helpers/Heading__Jsx3.bs.js");
let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");

function Property__Components$MissingFieldMarker(props) {
  let __className = props.className;
  let className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx("button", {
    children: props.text,
    className: TailwindMerge.twMerge([
      "max-w-full sm:max-w-64 leading-5 w-full text-center p-1.5 rounded border \n        text-zinc-600 bg-yellow-50 border-zinc-300 \n        hover:no-underline hover:text-zinc-600 hover:bg-yellow-100 cursor-pointer \n        transition-colors duration-150",
      className
    ]),
    onClick: props.onClick
  });
}

let MissingFieldMarker = {
  make: Property__Components$MissingFieldMarker
};

function Property__Components$SectionHeader(props) {
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(Heading__Jsx3.make, {
      as_: "h4",
      children: props.children
    }),
    className: "mb-5 pb-2.5 border-b border-zinc-200",
    id: props.id
  });
}

let SectionHeader = {
  make: Property__Components$SectionHeader
};

let Color;

exports.Color = Color;
exports.MissingFieldMarker = MissingFieldMarker;
exports.SectionHeader = SectionHeader;
/* Heading__Jsx3 Not a pure module */
